const SIGN_UP_NOT_AVAILABLE_MESSAGE = "Signup is not available for this account type";

interface ErrorMessageParams {
  errorMessage: string;
}

export function isSignUpNotAvailableErrorMessage({ errorMessage }: ErrorMessageParams): boolean {
  return errorMessage.includes(SIGN_UP_NOT_AVAILABLE_MESSAGE);
}

export function parseCognitoUsernameFromSignUpErrorMessage({
  errorMessage,
}: ErrorMessageParams): string | undefined {
  if (!isSignUpNotAvailableErrorMessage({ errorMessage })) {
    return undefined;
  }

  return /Identifier:\s*"([^"]+)"/.exec(errorMessage)?.[1];
}
